import React, { FC } from "react";

import Link from "../../../components/styled/Link";
import { ActivityLog } from "../../../store/pomeriumApi";

interface EntityDescriptionProps {
  activityLog: ActivityLog;
}

const EntityDescription: FC<EntityDescriptionProps> = ({ activityLog }) => {
  switch (activityLog?.entity?.type) {
    case "domain":
      return <>the domain: {activityLog?.entity?.data?.domainName}</>;
    case "custom_domain":
      return <>the custom domain: {activityLog?.entity?.data?.domainName}</>;
    case "key_pair":
      return (
        <>
          the key pair:{" "}
          <Link to={`/app/management/certificates/${activityLog?.entity?.id}`}>
            {activityLog?.entity?.data?.name}
          </Link>
        </>
      );
    case "namespace":
      return <>the namespace: {activityLog?.entity?.data?.name}</>;
    case "organization":
      return <>the organization: {activityLog?.entity?.data?.name}</>;
    case "policy":
      return (
        <>
          the policy:{" "}
          <Link to={`/app/management/policies/${activityLog?.entity?.id}/edit`}>
            {activityLog?.entity?.data?.name}
          </Link>
        </>
      );
    case "route":
      return (
        <>
          the route:{" "}
          <Link to={`/app/management/routes/${activityLog?.entity?.id}/edit`}>
            {activityLog?.entity?.data?.name}
          </Link>
        </>
      );
    case "settings":
      return <Link to="/app/settings">cluster settings</Link>;
    case "service_account":
      return (
        <>
          the service account:{" "}
          <Link
            to={`/app/management/service-accounts/${activityLog?.entity?.id}/view`}
          >
            {activityLog?.entity?.data?.description}
          </Link>
        </>
      );
    default:
      return <>entity</>;
  }
};
export default EntityDescription;
